import { all, fork } from "redux-saga/effects";
import action from "./actions";
import auth from "./auth";
import department from "./department";
import employee from "./employee";
import permission from "./permission";
import profile from "./profile";
import role from "./role";
import room from "./room";
import schoolHour from "./school-hour";
import subject from "./subject";
import teacher from "./teacher";
import teacherRole from "./teacher-role";
import user from "./user";

export default function* root() {
  yield all([
    fork(auth),
    fork(user),
    fork(room),
    fork(subject),
    fork(role),
    fork(permission),
    fork(action),
    fork(profile),
    fork(department),
    fork(schoolHour),
    fork(employee),
    fork(teacherRole),
    fork(teacher),
  ]);
}
